/* eslint-disable */
import { getLocale, trackMessageCall, experimentalMiddlewareLocaleSplitting, isServer, experimentalStaticLocale } from '../runtime.js';
/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

const en_rn_placeholder_encode = /** @type {(inputs: {}) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`1 to 3999`)
};

const es_rn_placeholder_encode = /** @type {(inputs: {}) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`1 al 3999`)
};

const de_rn_placeholder_encode = /** @type {(inputs: {}) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`1 bis 3999`)
};

const nl_rn_placeholder_encode = /** @type {(inputs: {}) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`1 tot 3999`)
};

const fr_rn_placeholder_encode = /** @type {(inputs: {}) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`1 à 3999`)
};

const it_rn_placeholder_encode = /** @type {(inputs: {}) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Da 1 a 3999`)
};

const pt_br2_rn_placeholder_encode = /** @type {(inputs: {}) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`1 a 3999`)
};

const pt_rn_placeholder_encode = /** @type {(inputs: {}) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`1 a 3999`)
};

const ja_rn_placeholder_encode = /** @type {(inputs: {}) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`1〜3999`)
};

const zh_rn_placeholder_encode = /** @type {(inputs: {}) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`1 到 3999`)
};

/**
* This function has been compiled by [Paraglide JS](https://inlang.com/m/gerre34r).
*
* - Changing this function will be over-written by the next build.
*
* - If you want to change the translations, you can either edit the source files e.g. `en.json`, or
* use another inlang app like [Fink](https://inlang.com/m/tdozzpar) or the [VSCode extension Sherlock](https://inlang.com/m/r7kp499g).
* 
* @param {{}} inputs
* @param {{ locale?: "en" | "es" | "de" | "nl" | "fr" | "it" | "pt-BR" | "pt" | "ja" | "zh" }} options
* @returns {LocalizedString}
*/
/* @__NO_SIDE_EFFECTS__ */
export const rn_placeholder_encode = (inputs = {}, options = {}) => {
	if (experimentalMiddlewareLocaleSplitting && isServer === false) {
		return /** @type {any} */ (globalThis).__paraglide_ssr.rn_placeholder_encode(inputs) 
	}
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	trackMessageCall("rn_placeholder_encode", locale)
	if (locale === "en") return en_rn_placeholder_encode(inputs)
	if (locale === "es") return es_rn_placeholder_encode(inputs)
	if (locale === "de") return de_rn_placeholder_encode(inputs)
	if (locale === "nl") return nl_rn_placeholder_encode(inputs)
	if (locale === "fr") return fr_rn_placeholder_encode(inputs)
	if (locale === "it") return it_rn_placeholder_encode(inputs)
	if (locale === "pt-BR") return pt_br2_rn_placeholder_encode(inputs)
	if (locale === "pt") return pt_rn_placeholder_encode(inputs)
	if (locale === "ja") return ja_rn_placeholder_encode(inputs)
	return zh_rn_placeholder_encode(inputs)
};